<template>
  <div>
    <div class="dialog-header">
      <h1>{{ title }}</h1>
    </div>
    <div class="dialog-content">
      {{ text }}
      <div class="footer-menu">
        <button class="pill-button" @click="close">
          {{ btnLabel }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['title', 'text', 'callback', 'btnLabel', 'btnUrl'],
  methods: {
    close() {
      this.callback(this.btnUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  margin-bottom: 55px;
}
</style>
